<template>
  <view class="checkbox-page">
    <base-container>
      <default-checked-checkbox></default-checked-checkbox>
      <disabled-checkbox></disabled-checkbox>
      <desc-checkbox></desc-checkbox>
      <styled-checkbox></styled-checkbox>
    </base-container>
  </view>
</template>

<script>
  import { createPage } from '@mpxjs/core'

  createPage({
    options: {
      styleIsolation: 'shared'
    }
  })
</script>

<style lang="stylus">
.checkbox-page
  height 100%
  background-color rgba(239, 239, 244, .7)
</style>

<script type="application/json">
  {
    "styleIsolation": "shared",
    "usingComponents": {
      "base-container": "../../components/base-container/index",
      "desc-checkbox": "./desc-support.mpx",
      "styled-checkbox": "./styled.mpx",
      "disabled-checkbox": "./disabled.mpx",
      "default-checked-checkbox": "./default-checked.mpx"
    }
  }
</script>
